import React, { Component } from "react";
import { FormGroup,
        FormControl,
        Tab,
        Tabs,
        Jumbotron } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./ViewSummary.css";
import axios from 'axios';
import ReactGA from 'react-ga';
import thumbsUpIcon from './like-2.svg';
import pencilIcon from './pencil.svg';
import config from "../config";
import Rater from 'react-rater'
import 'react-rater/lib/react-rater.css'
import Download from '@axetroy/react-download';

export default class ViewSummary extends Component {
  constructor(props) {
    super(props);

    this.initializeReactGA();

    this.file = null;

    this.state = {
      basicAuth: this.props.basicAuth,
      userId: this.props.userId,
      isLoading: false,
      summary: localStorage.getItem('cache_summary'),
      outline: localStorage.getItem('cache_outline'),
      summaryTopics: localStorage.getItem('cache_summaryTopics'),
      summaryTitle: this.getSummaryTitle(),
      selectedTopics: localStorage.getItem('cache_summaryTopics').split(','),
      showDeleteConfirm: false,
      topicPercent: 0.1,
      summaryStatus: null,
      rating: this.getSummaryRating(),
      feedback: ''
    };
  }

  initializeReactGA() {
    ReactGA.initialize('UA-136595020-1');
    ReactGA.pageview('/ViewSummary');
  }
  componentWillMount() {
    this.setState({ isLoading: true });
  }

  componentDidMount() {
    this.setState({ isLoading: false });
  }

  changeRating = event => {
    console.log(event.rating)
    this.setState({
      rating: event.rating
    });

    console.log('Update Summary Rating')
    console.log('summary id: ' + localStorage.getItem('cache_summaryId'))
    console.log('user id: ' + localStorage.getItem('cache_userId'))

    axios.post(config.API_HOST + '/summary/rating/update',
               {summary_id: localStorage.getItem('cache_summaryId'),
                user_id: localStorage.getItem('cache_userId'),
                rating: event.rating},
               {headers: { 'Content-Type': "application/json",
                          Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
    .then(res => {
      // Put response data in the console for now during dev
      console.log("Run summary response: ")
      console.log(res.data)
    })
    .catch (e =>
            {console.log('error ' + e.message);
             alert(e);
            });

  }

  getSummaryTitle(){
    if (localStorage.getItem('cache_summaryTitle')){
      return localStorage.getItem('cache_summaryTitle');
    } else {
      return "";
    }//if
  }

  getSummaryRating(){
    if (localStorage.getItem('cache_summaryRating')){
      return localStorage.getItem('cache_summaryRating');
    } else {
      return 0;
    }//if
  }

  validateForm() {
    return ((this.state.summary.length > 0) &&
            (this.state.summaryTitle.length > 0));
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSliderChange = event => {
    this.setState({topicPercent: event.target.value});
  }

  handleTitleChange = event => {
    this.setState({ summaryTitle: event.target.value })
  }

  handleSummaryChange = event => {
    this.setState({ summary: event.target.value })
  }

  handleFeedbackChange = event => {
    this.setState({ feedback: event.target.value })
  }

  handleOutlineChange = event => {
    this.setState({ outline: event.target.value })
  }

  deleteSummary = event => {
    this.setState({ isLoading: true });
    console.log('Delete Summary')
    console.log('summary id: ' + localStorage.getItem('cache_summaryId'))
    console.log('user id: ' + localStorage.getItem('cache_userId'))

      axios.post(config.API_HOST + '/summary/delete',
                 {summary_id: localStorage.getItem('cache_summaryId'),
                  user_id: localStorage.getItem('cache_userId')},
                 {headers: { 'Content-Type': "application/json",
                            Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
      .then(res => {
        // Put response data in the console for now during dev
        console.log("Run summary response: ")
        console.log(res.data)
        // clear summary list cache
        localStorage.removeItem('cache_summariesList')
        this.setState({ isLoading: false });
        this.props.history.push("/");
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }

  downloadSummary = event => {
    this.setState({ isLoading: true });
    console.log('Download Summary')
    console.log('summary id: ' + localStorage.getItem('cache_summaryId'))
    console.log('user id: ' + localStorage.getItem('cache_userId'))

      axios.post('http://ec2-18-228-191-89.sa-east-1.compute.amazonaws.com:8085/summary/download',
                 {summary_id: localStorage.getItem('cache_summaryId'),
                  user_id: localStorage.getItem('cache_userId')},
                 {headers: { 'Content-Type': "application/json",
                            Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
      .then(res => {
        // Put response data in the console for now during dev
        console.log("Run summary response: ")
        console.log(res)
        this.setState({ isLoading: false });
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }

  reRunSummary() {
    this.setState({ isLoading: true });
    this.setState({ summaryStatus: null });
    console.log('Rerun Summary')
    console.log('summary id: ' + localStorage.getItem('cache_summaryId'))
    console.log(this.state.selectedTopics)
    // console.log(localStorage.getItem('cache_summaryTopics'))
    console.log('user id: ' + localStorage.getItem('cache_userId'))

      axios.post(config.API_HOST + '/summary/run/rerun',
                 {summary_id: localStorage.getItem('cache_summaryId'),
                  topics: this.state.selectedTopics,
                  topic_percent: this.state.topicPercent,
                  user_id: localStorage.getItem('cache_userId')},
                 {headers: { 'Content-Type': "application/json",
                            Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
      .then(res => {
        // Put response data in the console for now during dev
        console.log("Run summary response: ")
        console.log(res.data)

        this.setState({ summaryStatus: res.data.status });

        // clear summary home page list cache
        localStorage.removeItem('cache_summariesList')

        console.log("Summary Id: ");
        console.log(localStorage.getItem('cache_summaryId'));
        // Pull the summary
        this.pollSummary(localStorage.getItem('cache_summaryId'), 0);
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }

  sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if ((new Date().getTime() - start) > milliseconds){
        return Promise.resolve();
      }
    }
  }

  pollSummary(id, retries = 0) {

    console.log("Start Checking summary status... " + id)

    // Need loop here to check and pull summary
      axios.post(config.API_HOST + '/summary/pull',
                 {summary_id: id},
                 {headers: { 'Content-Type': "application/json",
                            Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
      .then(res => {
        // Put response data in the console for now during dev
        console.log("Check summary status:")
        console.log(res.data);


        if (res.data.status === "Complete") {
          console.log('Summary Updated...')
          console.log(res.data)
          // store Summary info
          this.setState({ summaryStatus: null});
          this.props.setSummary(res.data);
          this.setState({ summary: res.data.summary });
          this.setState({ outline: res.data.outline });
          this.setState({ summaryTitle: res.data.title });
          this.setState({ isLoading: false });
          // Push user to summary view
          // this.props.history.push("/summary/view");
          return Promise.resolve(res.data); // success!

        } else if (retries >= 120) {
          this.setState({ summaryStatus: null});
          this.setState({ isLoading: false });
          return Promise.reject(res); // failure

        } else if (res.data.status === "ERROR") {
          this.setState({ summaryStatus: "Error Please Refresh"});
          return Promise.reject(res); // failure

        } else {
          // try again after delay
          this.setState({ summaryStatus: res.data.status});
          this.sleep(1000)
          return this.pollSummary(id, retries + 1);
        }
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }

  handleSubmit = event => {
    event.preventDefault();

    ReactGA.event({
      category: 'User',
      action: 'Save Summary'
    });

    this.setState({ isLoading: true });


      // Save summary
      axios.post(config.API_HOST + '/summary/save',
                 {user_id: localStorage.getItem('cache_userId'),
                  summary_id: localStorage.getItem('cache_summaryId'),
                  summary: this.state.summary,
                  outline: this.state.outline,
                  summary_title: this.state.summaryTitle},
                 {headers: { 'Content-Type': "application/json",
                            Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
      .then(res => {
        // Put response data in the console for now during dev
        console.log("Saved summary:")
        console.log(res.data);

        // Clear summary cache
        localStorage.removeItem('cache_summary');
        localStorage.removeItem('cache_summaryTopics');
        localStorage.removeItem('cache_summaryTitle');
        // clear summary home page list cache
        localStorage.removeItem('cache_summariesList')

        this.setState({ isLoading: false });
        this.props.history.push("/");
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }

  sendFeedback = event => {
    event.preventDefault();

    ReactGA.event({
      category: 'User',
      action: 'Send Feedback'
    });

    this.setState({ isLoading: true });


      // Save summary
      axios.post(config.API_HOST + '/summary/feedback/update',
                 {user_id: localStorage.getItem('cache_userId'),
                  summary_id: localStorage.getItem('cache_summaryId'),
                  feedback: this.state.feedback},
                 {headers: { 'Content-Type': "application/json",
                            Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
      .then(res => {
        // Put response data in the console for now during dev
        console.log("Summary Feedback send:")
        console.log(res.data);
        this.setState({ isLoading: false });
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }

  handleRemoveTopic(topic) {
    var arr = this.state.selectedTopics;
    for( var i = 0; i < arr.length; i++){
      if ( JSON.stringify(arr[i]) === JSON.stringify(topic)) {
        // remove element before array
        arr.splice(i, 1)
        this.setState({ selectedTopics: arr})
      }
    }
  }

  handleCheck(topic) {
    return this.state.selectedTopics.includes(topic);
  }

  handleSelectedTopicsChange(topic) {
    // current array of options
    console.log(topic.target.value)
    console.log(this.state.selectedTopics)
    const selectedTopics = this.state.selectedTopics

    // check if the check box is checked or unchecked
    if (topic.target.checked) {
      // add the numerical value of the checkbox to options array
      selectedTopics.push(topic.target.value)
    } else {
      // or remove the value from the unchecked checkbox from the array
      this.handleRemoveTopic(topic.target.value)
    }

    // update the state with the new array of options
    this.setState({ selectedTopics: selectedTopics })
    console.log(this.state.selectedTopics)
  }

  calculateReadTime(words){
    return parseInt(words / 200)
  }

  renderTopics() {
    var topicsArray= this.state.summaryTopics.split(',');

    return [].concat(topicsArray).map((topic, i) =>
          <div id='ck-button'>
            <label>
            <input hidden
                    type="checkbox"
                    value={topic}
                    key={i}
                    id={i}
                    checked={this.handleCheck(topic)}
                    onChange={this.handleSelectedTopicsChange.bind(this)} />
                    <span> {JSON.parse(JSON.stringify(topic))} </span>
            </label>
          </div>
      );
  }

  renderTabs() {
    return (

      <div>
      {this.state.isAuthenticated
        ? <Tabs
                id="input-selection"
                activeKey={this.state.inputType}
                onSelect={inputType => this.setState({ inputType })}
              >
            <Tab eventKey="summary" title="Summary">
              <FormGroup controlId="content">
                <FormControl
                  rows="15" cols="50"
                  onChange={this.handleSummaryChange}
                  value={this.state.summary}
                  componentClass="textarea"
                />
              </FormGroup>
            </Tab>
            <Tab eventKey="outline" title="Outline">
              <FormGroup controlId="file">
                <FormControl
                  rows="15" cols="50"
                  onChange={this.handleOutlineChange}
                  value={this.state.outline}
                  componentClass="textarea"
                  />
              </FormGroup>
            </Tab>
          </Tabs>
        : <FormGroup controlId="content">
            <FormControl
              rows="15" cols="50"
              onChange={this.handleSummaryChange}
              value={this.state.summary}
              componentClass="textarea"
            />
          </FormGroup> }
        </div>
    );
  }

  renderStars() {
    const starStyle = {
      fontSize: '30px',
    };

    return (
      <span>
        <h2> Summary Rating </h2>
        <Rater total={5}
               style={starStyle}
               rating={this.state.rating}
               onRate={this.changeRating}
      />
      <FormGroup controlId="feedback">
            <FormControl
              rows="3" cols="10"
              onChange={this.handleFeedbackChange}
              value={this.state.feedback}
              componentClass="textarea"
              placeholder='We love any feedback...'
            />
          </FormGroup>
      <LoaderButton
        block
        bsStyle="primary"
        bsSize="large"
        type="submit"
        isLoading={this.state.isLoading}
        text="Send Feedback"
        loadingText="Sending..."
        onClick={this.sendFeedback.bind(this)}
      />
      </span>
      );
  }

  renderDownload() {
    return (
      <div>
          <Download file={'Autonote_' + this.state.summaryTitle + '.doc'}
                    content={this.state.summaryTitle + '\n\n' + this.state.summary} >
            <LoaderButton
                block
                bsStyle="primary"
                bsSize="large"
                text='Download' />
          </Download>
      </div>
      );
  }


  render() {
    return (
      <div className="ViewSummary">

       <div id="tile">
        <h2> Topics Found </h2>
        <h4> Hint: click on a topic, then click update to resummarize without focusing on that topic </h4>
          {this.renderTopics()}

            <LoaderButton
              block
              bsStyle="primary"
              bsSize="large"
              type="submit"
              isLoading={this.state.isLoading}
              text="Update Summary"
              loadingText={this.state.summaryStatus}
              onClick={this.reRunSummary.bind(this)}
            />
        </div>


        <div id="tile">
        <h2> Summary Stats </h2>

            <h4> Word Count: {localStorage.getItem('cache_summaryOriginalWordCount')} to {localStorage.getItem('cache_summaryWordCount')}</h4>
            <h4> Read Time: {this.calculateReadTime(localStorage.getItem('cache_summaryOriginalWordCount'))} to {this.calculateReadTime(localStorage.getItem('cache_summaryWordCount'))} Minutes
            </h4>
        </div>

            <div id="tile">
            <h2> Summary </h2>

          <form onSubmit={this.handleSubmit}>
            {this.renderTabs()}

          {this.renderDownload()}

          {this.state.isAuthenticated
          ?<div>
            <LoaderButton
                block
                bsStyle="primary"
                bsSize="large"
                disabled={!this.validateForm()}
                type="submit"
                isLoading={this.state.isLoading}
                text="Save"
                loadingText="Saving…"
              />
            <LoaderButton
                block
                bsStyle="primary"
                bsSize="large"
                type="submit"
                isLoading={this.state.isLoading}
                text="Delete"
                loadingText="Deleting…"
                onClick={this.deleteSummary}
              />
            </div>
          : <div/>}

            </form>
           </div>
           <div id="tile">
            {this.renderStars()}
           </div>

      </div>
    );
  }
}

